import { css, CSSResultGroup } from 'lit';
import { rem, whereNotLastChild } from '../css.helper';
import { resetCss } from './reset.css';
import { tableCss } from './table.css';

export const globalCss: CSSResultGroup = [
  resetCss,
  tableCss,

  // Global styles
  css`
    ${whereNotLastChild(
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'],
      css`
        margin-block-end: ${rem(16)};
      `,
    )}

    :where(ul, ol) {
      padding-inline-start: ${rem(20)};

      tmwc-content-inline-text {
        margin-block-end: ${rem(8)};
      }
    }

    :where(li) {
      * {
        margin-block-end: unset;
      }

      ul:last-child,
      ol:last-child {
        margin-block-end: ${rem(16)};
      }
    }

    :where(ol::marker) {
      background: red;
    }

    li:first-child {
      break-after: avoid;
    }

    li:last-child {
      break-before: avoid;
    }

    :where(.hyphenated-list) {
      list-style-type: '-   ';

      ul {
        list-style-type: '-   ';
      }
    }
  `,
];
